import React from 'react'
import QueryManager from './Query'
import gql from 'graphql-tag'
import { bool, any, string } from 'prop-types'
import { get } from 'lodash'

const GET_USER_BY_EMAIL_QUERY = gql`
  query getPickerByEmail ($email: String!) {
    pickerByEmail(email: $email) {
      id
      firstName
      lastName
    }
  }
`

const GetPickerByEmail = ({ children, email, ...props }) => (
  <QueryManager query={GET_USER_BY_EMAIL_QUERY} variables={{ email }}>
    {({ data, loading }) => {
      const firstName = get(data, 'pickerByEmail.firstName', '-')
      const lastName = get(data, 'pickerByEmail.lastName', '-')
      return children({
        data,
        firstName,
        lastName,
        fullName: `${firstName} ${lastName}`,
        loading
      })
    }}
  </QueryManager>
)

GetPickerByEmail.propTypes = {
  loading: bool,
  children: any,
  data: any,
  email: string
}

export default GetPickerByEmail

export {
  GET_USER_BY_EMAIL_QUERY
}
